// Class strings shared across the mobile pages and shared UI.

/**
 * Amber text that stays readable: raw Amber Honey on Linen is ~2:1, so light
 * mode uses the dark amber foreground token and dark mode the amber itself.
 */
export const WARN_TEXT = 'font-semibold text-warning-foreground dark:text-warning'

/** Press feedback shared by rows, tiles and cards. */
export const PRESSABLE =
  'transition-transform duration-150 ease-out active:scale-[0.97] motion-reduce:transition-none motion-reduce:active:scale-100'

/**
 * Sage text that passes AA: Sage on White is ~3.2:1, so light mode uses Dark
 * Sage (#5C7A6B, 5.1:1, per DESIGN.md) and dark mode Sage Light.
 */
export const SAGE_TEXT = 'text-[#5C7A6B] dark:text-primary'
